module.exports = __webpack_public_path__ + "static/media/gamovore.7acc3b22.png";